import { render, staticRenderFns } from "./SwapSettingsCard.vue?vue&type=template&id=ba01b6f2&scoped=true"
import script from "./SwapSettingsCard.vue?vue&type=script&lang=ts"
export * from "./SwapSettingsCard.vue?vue&type=script&lang=ts"
import style0 from "./SwapSettingsCard.vue?vue&type=style&index=0&id=ba01b6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba01b6f2",
  null
  
)

export default component.exports